(function () {
    'use strict';
    app.controller('landingController', ['$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', '$routeParams', 'LoginService', function ($scope, $location, $cookies, progressBarService, $rootScope, $timeout, $routeParams, loginService) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') == 'SAdmin') {
            $location.path('/login');
            return
        }
        $scope.ispremiumUser = getLocalValue('isPremiumMember')
        $scope.isPrimaryAdmin = getLocalValue('userRole').toLowerCase() == "primary administrator" ? true : false;
        $scope.SurveyMonkeyPopupLoadTime = getCookie("surveyMonkeyPopupLoadTime", $cookies)
        
        $scope.popupExtraInfo = function () {
            if ($rootScope.isFirstLogin == '1') {
                $('#extraInfo').modal({ backdrop: 'static', keyboard: false });
                //$rootScope.isFirstLogin = '0';
            }
        }

        

        $scope.dataModel = {
            currentPosition: "",
            industry: "",
            interest: "",
            peerReviewerYes: 0,
            currentProject: "",
            maxInterestLength: 100
        }

        var hideMessage = function () {
            $scope.isModalError = false;
            $scope.isModalSuccess = false;
            $scope.modalMessage = '';
        }


        $rootScope.$broadcast('getTeamInfo', {});

        $scope.submitData = function () {
            //var peerReviewerFlag = $('#yes')[0].checked ? 1 : 0;

            var data = {
                eSpectraProfessionalTitle: $scope.dataModel.currentPosition,
                eSpectraPrimaryAreaOfInterest: $scope.dataModel.interest,
                eSpectraLatestProject: $scope.dataModel.currentProject,
                eSpectraPrimaryIndustry: $scope.dataModel.industry,
                // eSpectraSSSPeerReviewerFlag: peerReviewerFlag,
                //eSpectraPersonID: $cookies.get('UserId')
            };

            loginService.saveExtraInfo(data).then(function (response) {
                if (response == null) {
                    //$('#extraInfo').modal('hide');
                    //if ($rootScope.hasSharedWorkspaces == '1') {
                    //    $location.path('/savedWorkedSpace');
                    //}
                    $scope.hideModal();
                }
                else {
                    $scope.modalMessage = response.data.message;
                    $scope.isModalError = true;
                    $scope.isModalSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
            });
        }

        $scope.hideModal = function () {
            $('#extraInfo').modal('hide');
            if ($rootScope.hasSharedWorkspaces == '1') {
                $location.path('/savedWorkedSpace');
            } else {
                $rootScope.isFirstLogin = '0';
            }
        }

        $scope.popupExtraInfo();

        if ($rootScope.buildConfig.surveyMonkeyAfterLogin) {
            $timeout(function () {
                (function (t, e, s, o) { var n, c, l; t.SMCX = t.SMCX || [], e.getElementById(o) || (n = e.getElementsByTagName(s), c = n[n.length - 1], l = e.createElement(s), l.type = "text/javascript", l.async = !0, l.id = o, l.src = "https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd_2BNHLyIwmuFE7cezwkskiixLls5pSrhPm15gxny5PVsU.js", c.parentNode.insertBefore(l, c)) })(window, document, "script", "smcx-sdk");
            }, $scope.SurveyMonkeyPopupLoadTime);
        }
        
    }]);
})();